define.alias("ember-composable-helpers/helpers/pipe-action", "media/helpers/pipe-action");